import React from 'react';
import PropTypes from 'prop-types';

import defaultImage from '../../assets/modal/FanZone-Generic.jpg';
import { buildAnchorLink } from '../../utils/helpers';
import './FanZone.css';


function AnchorFanzone(props) {
  const getAnchorLink = (anchor) => {
    if (props.isDiscountPage) {
      return props.checkoutLink(anchor);
    }

    return buildAnchorLink(anchor, '?filter=fanzone');
  };

  return (
    <React.Fragment>
      <div className={`anchorsContainer ${props.isDiscountPage && 'discount-page'}`}>
        <div className={`fanZoneAnchors ${props.classes}`}>
          {props.fanzones.map((anchor) => (
            <a
              key={anchor.id}
              className="anchorContainer"
              href={getAnchorLink(anchor)}
            >
              <div
                className="fanZoneAnchor"
                style={{
                  backgroundImage: `url(${anchor.joinOverlay ||
                defaultImage})`,
                }}
              >
                <div className="anchorName">{anchor.name}</div>
                <div className="anchorDesc">{anchor.description}</div>
                <div className="tint" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
}

export default AnchorFanzone;

AnchorFanzone.propTypes = {
  classes: PropTypes.string,
  fanzones: PropTypes.array.isRequired,
  isDiscountPage: PropTypes.func,
};
